import { RouteRecordRaw as VueRouteConfig, RouteLocationNormalized as VueRouteNormalized } from 'vue-router';
import { Logger } from '../utils/logger.util';
import { AbstractRouterOptions, Route, RouteNameOrLocation, SeamlessRouteConfig } from './types';

export default abstract class AbstractRouter {
  options: AbstractRouterOptions;

  abstract get routes(): (VueRouteConfig | SeamlessRouteConfig)[];

  abstract push(args: RouteNameOrLocation, onComplete?: () => void): void;

  abstract replace(args: RouteNameOrLocation, onComplete?: () => void): void;

  abstract getCurrentRoute(): Route;

  abstract onRouteChange(cb: (to: Route | VueRouteNormalized, from: Route | VueRouteNormalized) => void): void;

  findRouteConfig(nameOrPath: string) {
    const routeConfig = this.routes.find(
      (route) => route.name === nameOrPath || nameOrPath.startsWith(route.path as string),
    );

    if (!routeConfig) {
      Logger.error(`unknown route: '${nameOrPath}'`);
    }

    return routeConfig;
  }
}
